import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _PaymentMethodGetter = Getter.of();
export const _PaymentMethodResponseGetter = Getter.of();
export const _PaymentMethodsGetter = Getter.of();
export const _PaymentMethodsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _PaymentMethodsResponse2PaymentMethods = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _PaymentMethodResponse2PaymentMethod = _Response2ResponseData();
export const _PaymentMethod2Attributes = Fold.compose(Res._Response(), Lens.prop("attributes"));
export const _PaymentMethodAttributes2Provider = Fold.compose(_PaymentMethod2Attributes, Lens.prop("provider"));
export const _PaymentMethodAttributes2Status = Fold.compose(_PaymentMethod2Attributes, Lens.prop("status"));
export const _PaymentMethodAttributes2PaymentType = Fold.compose(_PaymentMethod2Attributes, Lens.prop("paymentType"));
export const _PaymentMethodAttributes2CardExpire = Fold.compose(_PaymentMethod2Attributes, Lens.prop("cardExpire"));
export const _PaymentMethodAttributes2CardProvider = Fold.compose(_PaymentMethod2Attributes, Lens.prop("cardProvider"));
export const _PaymentMethodAttributes2MaskedCardNumber = Fold.compose(_PaymentMethod2Attributes, Lens.prop("maskedCardNumber"));
export const _PaymentMethod2PostalAddress = Fold.compose(_PaymentMethodGetter, Res._Rel("postalAddress"));

